import { Box, Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../../../components/Dialog';

export type PurchaseTransactionPdfOptions = {
    hideVehicleNo: boolean;
    includeTransactionData: boolean;
    includeDealerQuotes: boolean;
};

type ExportPurchaseTransactionPdfDialogProps = {
    open: boolean;
    onClose: () => void;
    onExport: (options: PurchaseTransactionPdfOptions) => void;
    defaultHideVehicleNo: boolean;
};

const defaultOptions: PurchaseTransactionPdfOptions = {
    hideVehicleNo: false,
    includeTransactionData: false,
    includeDealerQuotes: false,
};

const ExportPurchaseTransactionPdfDialog = ({
    open,
    onClose,
    onExport,
    defaultHideVehicleNo,
}: ExportPurchaseTransactionPdfDialogProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage', 'common']);
    const [options, setOptions] = useState({ ...defaultOptions, hideVehicleNo: defaultHideVehicleNo });

    useEffect(() => {
        if (open) {
            setOptions({ ...defaultOptions, hideVehicleNo: defaultHideVehicleNo });
        }
    }, [defaultHideVehicleNo, open]);

    const updateOption = (option: keyof PurchaseTransactionPdfOptions) => (event: ChangeEvent<HTMLInputElement>) => {
        setOptions(currentOptions => ({
            ...currentOptions,
            [option]: event.target.checked,
        }));
    };

    return (
        <Dialog
            maxWidth="xs"
            onCloseClick={onClose}
            open={open}
            title={t('purchaseTransactionsPage:exportPdfDialog.title')}
            fullWidth
        >
            <Box display="flex" flexDirection="column">
                <FormControlLabel
                    control={<Checkbox checked={options.hideVehicleNo} onChange={updateOption('hideVehicleNo')} />}
                    label={t('purchaseTransactionsPage:exportPdfDialog.hideVehicleNo')}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={options.includeTransactionData}
                            onChange={updateOption('includeTransactionData')}
                        />
                    }
                    label={t('purchaseTransactionsPage:exportPdfDialog.transactionData')}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={options.includeDealerQuotes}
                            onChange={updateOption('includeDealerQuotes')}
                        />
                    }
                    label={t('purchaseTransactionsPage:exportPdfDialog.dealerQuotes')}
                />
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button color="secondary" onClick={onClose}>
                        {t('common:cancel')}
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => {
                            onExport(options);
                            onClose();
                        }}
                        variant="contained"
                    >
                        {t('purchaseTransactionsPage:exportPdfDialog.export')}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default ExportPurchaseTransactionPdfDialog;
